<template>
    <div v-if="summary" :class="statusStyling">
      <v-icon :color="statusIconColor">
        {{statusIcon}}
      </v-icon>
      {{ summary }}. {{summaryError}}
    </div>
</template>

<script>
import { StatsAndErrors } from '@/components/mapping'

export default {
  name: 'mapping-summary',
  props: {
    // errorMessages: null,
    fieldMapping: {
      type: Array,
      required: true
    },
    lhsValues: {
      type: Array,
      required: true
    },
    rhsValues: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      summary: '',
      isValid: true,
      warnings: 0,
      summaryError: null,
      icons: {
        ok: 'mdi-check',
        warning: 'mdi-alert',
        invalid: 'mdi-close'
      },
      iconColor: {
        ok: 'green',
        warning: 'orange',
        invalid: 'error'
      },
      styling: {
        ok: 'v-messages theme--light',
        warning: 'v-messages theme--light orange--text',
        invalid: 'v-messages theme--light error--text'
      }
    }
  },
  watch: {
    fieldMapping () {
      this.updateStats()
    },
    lhsValues () {
      this.updateStats()
    },
    rhsValues () {
      this.updateStats()
    }
  },
  computed: {
    status: function () {
      if (this.isValid && this.warnings === 0) {
        return 'ok'
      } else if (this.isValid && this.warnings > 0) {
        return 'warning'
      } else {
        return 'invalid'
      }
    },
    statusIcon: function () {
      return this.icons[this.status]
    },
    statusIconColor: function () {
      return this.iconColor[this.status]
    },
    statusStyling: function () {
      return this.styling[this.status]
    }
  },
  methods: {
    updateStats () {
      const stats = StatsAndErrors(this.fieldMapping, this.lhsValues, this.rhsValues)
      this.summary = stats.summary
      this.isValid = stats.isValid
      this.warnings = stats.warnings
      this.summaryError = stats.summaryError
    }
  }
}
</script>
